export default __webpack_public_path__ + "static/media/Mask Group 11-Tata@2x.070ac80d.png";